/**
 * Bedenimi Bul — Wizard Preview (Sade Şablon)
 *
 * Sayz'ın "wow-inducing" wizard'ı. Tek HTML iskelet, tema layer'ı Sayz Widget'tan
 * miras alır. Sade şablonun DNA'sı:
 *   • Tipografi ağır çeker (soru = cümle, form label değil)
 *   • Tek ekran = tek odak (bilgi kalabalığı yok)
 *   • Anlamlı motion (adım geçişi slide+fade, siluet pulse, sonuç reveal)
 *   • Kişilikli metinler (robot değil, arkadaş)
 *   • Premium detaylar (48px+ beden, stepper input, chip stagger)
 *
 * Preview sabit 8 ekranı gösterir; canlı embed script ürünün ölçü grubuna göre
 * alakalı olanları akıtır (farklı kod). Nazik Ret varyantı sadece davranış
 * "kind_refusal" ise merchant için ek pill olarak görünür.
 *
 * This file is now a BARREL that re-exports the public compound API. The
 * implementation lives under `./wizard/` — context + Modal + Navigator +
 * step/part components. Public import paths are unchanged.
 */
import { WizardPreviewProvider } from "./wizard/context";
import { WizardPreviewModal } from "./wizard/WizardPreviewModal";
import { ScreenSelector } from "./wizard/parts/ScreenSelector";
import { useWizardCtx } from "./wizard/context";

// Re-export public API ─────────────────────────────────────────────────────
export { performHostAutoSelect, checkHostSizeStock } from "./wizard/host-integration";
export { WizardPreviewProvider } from "./wizard/context";
export { WizardPreviewModal } from "./wizard/WizardPreviewModal";

// ═══════════════════════════════════════════════════════════════════════════
// Compound API — state lives in Provider, Modal + Navigator consume it
// so the merchant page can render the step selector OUTSIDE the preview card.
// ═══════════════════════════════════════════════════════════════════════════
export const WizardPreviewNavigator = () => {
    const { accent, settings, step, previewRefusal, goTo, recallScenario, activateRecallScenario, visibleSteps } = useWizardCtx();
    return (
        <ScreenSelector
            step={step}
            previewRefusal={previewRefusal}
            onSelectStep={goTo}
            recallScenario={recallScenario}
            onSelectRecall={activateRecallScenario}
            accent={accent}
            showRefusalPill={settings.outOfRangeStrategy === "kind_refusal"}
            smartRecallEnabled={settings.smartRecall?.enabled !== false}
            fastPathMode={settings.smartRecall?.fastPathMode || "auto_recommend"}
            visibleSteps={visibleSteps}
        />
    );
};

export const WizardPreview = ({ accent, settings, modalTitle }) => {
    // Backwards-compatible single-render API. Prefer the compound components
    // (WizardPreviewProvider + WizardPreviewModal + WizardPreviewNavigator)
    // when the navigator needs to live outside the preview Card.
    return (
        <WizardPreviewProvider accent={accent} settings={settings} modalTitle={modalTitle}>
            <div className="space-y-4">
                <WizardPreviewModal />
                <WizardPreviewNavigator />
            </div>
        </WizardPreviewProvider>
    );
};
